import React from 'react';
import './style.css';

const Privacy: React.FC = () => {
  return (
      <div className="privacy-container">
        <div className="privacy-content">
          <h1>王导导网约车导航小助手的隐私政策</h1>
          <p className="update-date">更新日期：2024年3月1日</p>

          <section>
            <h2>1. 引言</h2>
            <p>
              感谢您选择使用由北京紫源科技有限公司（以下简称"我们"）开发、运营的王导导网约车导航小助手。我们非常重视您的个人信息和隐私保护。
            </p>
          </section>

          <section>
            <h2>2. 我们收集的信息</h2>
            <h3>2.1 您主动提供的信息</h3>
            <p>为了提供基础服务，请您务必仔细阅读本政策。我们将遵一如既往完善示我们处理、管理以及保护您的相关信息。</p>
            <p>本服务的任何部分会全部的过程中收集的个人信息，本政策中与您的权益（可能）密切相关的条款，已采用加粗字体特别提醒您，请您重点阅读。</p>
          </section>

          <section>
            <h2>3. 信息的使用</h2>
            <p>为有效保护、保护您的个人信息，我们设立了专门的个人信息保护团队和负责人。如果您对本政策中有任何问题、意见或建议，请通过以下方式与我们联系。我们会在三十个工作日内完成处理。</p>
            <p>邮箱：wuning701122@163.com</p>
          </section>

          <section>
            <h2>4. 信息的共享</h2>
            <p>请您理解，我们会基于本隐私政策列明的收集所收集您的个人信息，其中包括下：</p>
            <ul>
              <li>设备信息：设备型号、操作系统版本、设备设置等</li>
              <li>位置信息：用于提供导航服务</li>
              <li>使用记录：您使用本应用的操作记录、使用时间等</li>
              <li>性能数据：应用崩溃记录、性能数据等</li>
            </ul>
          </section>

          <section>
            <h2>5. 信息的存储和保护</h2>
            <p>
              我们采取业界标准的安全措施保护您的个人信息安全。这些措施包括但不限于数据加密、访问控制等。
              所有数据均存储在中国境内的服务器上，并严格遵守相关法律法规的要求。
            </p>
          </section>

          <section>
            <h2>6. 您的权利</h2>
            <p>根据相关法律法规，您享有以下权利：</p>
            <ul>
              <li>访问、更正或删除您的个人信息</li>
              <li>撤回您的同意</li>
              <li>注销您的账号</li>
              <li>投诉举报的权利</li>
            </ul>
          </section>

          <section>
            <h2>7. 隐私政策的更新</h2>
            <p>
              我们可能会不时更新本隐私政策。当我们对隐私政策做出重大变更时，我们会通过应用内通知或其他合适的方式通知您。
            </p>
          </section>

          <section>
            <h2>8. 联系我们</h2>
            <p>
              如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式与我们联系：<br />
              邮箱：wuning701122@163.com
            </p>
          </section>
        </div>
      </div>
  );
};

export default Privacy;
